var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.01653 8.935C9.09274 8.42757 9.37661 8.15359 9.66119 7.96017C9.93946 7.771 10.2177 7.52541 10.2177 7.07076C10.2177 6.44323 9.71432 5.935 9.09274 5.935C8.47116 5.935 7.96774 6.44323 7.96774 7.07076M6.97066 13.8627L8.51945 15.161C8.79692 15.3936 9.20094 15.3947 9.47974 15.1638L11.0535 13.86C11.188 13.7485 11.3572 13.6875 11.5319 13.6875H13.6875C14.5159 13.6875 15.1875 13.0159 15.1875 12.1875V4.3125C15.1875 3.48407 14.5159 2.8125 13.6875 2.8125H4.3125C3.48407 2.8125 2.8125 3.48407 2.8125 4.3125V12.1875C2.8125 13.0159 3.48407 13.6875 4.3125 13.6875H6.48886C6.66506 13.6875 6.83563 13.7495 6.97066 13.8627Z",
    stroke: "#FF7926",
    strokeWidth: 1.13,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.525 10.6875C8.525 10.9498 8.73766 11.1625 9 11.1625C9.26234 11.1625 9.475 10.9498 9.475 10.6875C9.475 10.4252 9.26234 10.2125 9 10.2125C8.73766 10.2125 8.525 10.4252 8.525 10.6875Z",
    fill: "#FF7926",
    stroke: "#FF7926",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.cf6243527d58f4ebfbc012ac59ef3027.svg";
export { ForwardRef as ReactComponent };